import * as Rx from 'rxjs';
import { map, tap } from 'rxjs/operators';
import apiService from 'v2/services/api';

import type { IWarningReturn } from 'v2/interfaces/warning';

import type { Observable } from 'rxjs';

/**
 * Service responsible for controlling `Warning` component.
 *
 * @class WarningService
 */
class WarningService {
  /**
   * @method loadGlobalWarning
   * @return {Observable} an array of `IWarningReturn` with the enabled configs on spreadsheet
   * returned by the API
   */

  private warning$ = new Rx.BehaviorSubject<IWarningReturn>(null);

  public setAnswered(): void {
    this.warning$.next({ ...this.warning$.value, ...{ answered: true } });
  }

  public getWarning = (): Observable<IWarningReturn> => this.warning$;
  public loadGlobalWarning = (): void => {
    apiService
      .get<IWarningReturn[]>('https://orbita-spreadsheet.eduzz.com/hints/warnings')
      .pipe(
        map((response) => (Array.isArray(response) ? response : [])),
        map((warnings) => warnings.find((warning) => warning.enabled === true && warning.name.includes('global_warning'))),
        tap((warning) => (warning ? (warning.answered = Boolean(localStorage.getItem(warning?.name))) : false)),
        tap((warning) => this.warning$.next(warning))
      )
      .subscribe();
  };
}

const WarningServiceFactory = new WarningService();
export const warningsFactory = WarningServiceFactory;
